import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../Item/Item.css';

const TableNameEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({ Name: '', IsParcel: false, GstNotApplicable: false });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    useEffect(() => {
        fetchData('TableNameApi', '/TableNameDetails/' + id, token)
            .then((r) => { if (r.responseCode === '1111') setFormData(r.response_data); })
            .catch((e) => console.error('Error fetching Table Name Details:', e));
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? !prev[name] : value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateData('TableNameApi', '' + id, { ...formData, UpdatedBy: userId }, token)
            .then(() => history.push('/TableNameIndex'))
            .catch((e) => console.error('Error updating record:', e));
    };

    return (
        <div className="item-container">
            <div className="item-header-card">
                <div className="item-header-content">
                    <div className="item-title-section">
                        <span className="item-title-icon"><TableRestaurantIcon fontSize="small" /></span>
                        <h1 className="item-title">Table Name Edit</h1>
                    </div>
                    <div className="item-header-actions">
                        <button className="it-btn it-btn-update" onClick={handleSubmit}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Update
                        </button>
                        <Link to="/TableNameIndex" className="it-btn it-btn-back">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Back
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="item-alert item-alert-error">{errorMessage}</div>}

            <div className="item-form-card">
                <p className="item-form-section-title">Table Information</p>
                <div className="item-form-row">
                    <div className="item-form-group w-3">
                        <label className="item-label">Table Name <span className="required">*</span></label>
                        <input className="item-input" name="Name" value={formData.Name} onChange={handleChange} type="text" placeholder="Enter table name" required maxLength={20} />
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">Include Parcel Charge?</label>
                        <div className="item-checkbox-group">
                            <input className="item-checkbox" type="checkbox" id="IsParcel" name="IsParcel" checked={formData.IsParcel} onChange={handleChange} />
                            <label className="item-checkbox-label" htmlFor="IsParcel">Yes</label>
                        </div>
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">GST Not Applicable?</label>
                        <div className="item-checkbox-group">
                            <input className="item-checkbox" type="checkbox" id="GstNotApplicable" name="GstNotApplicable" checked={formData.GstNotApplicable} onChange={handleChange} />
                            <label className="item-checkbox-label" htmlFor="GstNotApplicable">Yes</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableNameEdit;
